import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { DialogMode } from 'src/app/shared/atlas-dialog/enums/dialog-mode.enum';
import { Scenario } from '../../../models/scenario';
import { AddEditScenarioFormComponent } from '../add-edit-scenario-form/add-edit-scenario-form.component';
import { Subscription } from 'rxjs';
import { ScenarioService } from 'src/app/spatial-modeller/services/scenario.service';
import * as fromSmStore from 'src/app/spatial-modeller-store';
import { updateScenarioDialogSaveClicked } from 'src/app/spatial-modeller-store/actions/scenario.actions';
import { DialogResult } from 'src/app/shared/atlas-dialog/enums/dialog-result.enum';

@Component({
  selector: 'atlas-edit-scenario-dialog',
  templateUrl: './edit-scenario-dialog.component.html',
  styleUrls: ['./edit-scenario-dialog.component.less'],
  standalone: false
})
export class EditScenarioDialogComponent implements OnInit, OnDestroy {
  dialogMode: DialogMode;
  userScenarios: string[] = [];
  sharedScenarios: Scenario[] = [];
  private subscription = new Subscription();
  ownScenarios: string[];

  constructor(
    private scenarioService: ScenarioService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      entityName: string;
      headerPrefix: string;
      mode: DialogMode;
      scenario: Scenario;
      affirmativeButtonText: string;
    },
    private dialogRef: MatDialogRef<EditScenarioDialogComponent>,
    private store$: Store<fromSmStore.State>
  ) {}

  ngOnInit() {
    this.getAllScenarios();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private getAllScenarios() {
    this.subscription.add(
      this.scenarioService
        .getAllScenarios()
        .subscribe((scenarios: Scenario[]) => {
          this.userScenarios = scenarios
            .filter((scenario) => this.data.scenario.name !== scenario.name)
            .map((scenario) => scenario.name);
          this.sharedScenarios = scenarios.filter(
            (scenario) => scenario.isShared
          );
          this.ownScenarios = scenarios
            .filter((s) => s.isCreator)
            .map((s) => s.name);
        })
    );
  }

  onSaveClicked(editScenarioFormComponent: AddEditScenarioFormComponent) {
    const newScenario = editScenarioFormComponent.addEditScenarioForm.value;
    // When scenarioName control is disabled (for shared scenarios),
    // Angular excludes it from form.value.
    // In that case, fallback to the existing scenario name from dialog data.
    const scenarioName = newScenario.scenarioName || this.data?.scenario?.name;

    if (editScenarioFormComponent.addEditScenarioForm.valid) {
      this.store$.dispatch(
        updateScenarioDialogSaveClicked({
          id: newScenario.id,
          scenarioRequest: {
            name: scenarioName,
            baseNames: newScenario.baseScenarios,
            deltaNames: newScenario.deltaScenarios,
            isShared: newScenario.permissionLevel === 'shared'
          }
        })
      );

      this.dialogRef.close({
        action: DialogResult.Affirmative,
        data: scenarioName
      });
    }
  }
}
